import { Button } from '@blueprintjs/core';
import DetailPanel from 'Components/Generic/DetailPanel';
import OrgRoles from 'Components/Generic/Roles/OrgRoles';
import UserOrgRolesPanel from 'Components/Generic/Roles/UserOrgRolesPanel';
import PropTypes from 'prop-types';
import { useState } from 'react';
import styles from 'Styles/styles.module.css';

const OrgRolesPanel = ({ orgId, editable = false }) => {
  const [groupRolesByUser, setGroupRolesByUser] = useState(false);

  return (
    <DetailPanel
      title={'Core Facility Users'}
      collapsible
      editable={editable && !!orgId}
      disabled={!orgId}>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
        }}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'end',
          }}>
          <Button
            className={styles.primary_button_minimal}
            style={{ padding: '0 4px', marginBottom: '-12px' }}
            onClick={() => setGroupRolesByUser(!groupRolesByUser)}>
            {groupRolesByUser ? 'Group by roles' : 'Group by users'}
          </Button>
          {groupRolesByUser ? (
            <UserOrgRolesPanel
              detailsOnly
              orgId={orgId}
              editable={editable && !!orgId}
            />
          ) : (
            <OrgRoles orgId={orgId} editable={editable && !!orgId} />
          )}
        </div>
      </div>
    </DetailPanel>
  );
};

OrgRolesPanel.propTypes = {
  orgId: PropTypes.number,
  editable: PropTypes.bool,
};

export default OrgRolesPanel;
